import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import NotesRow from '../NotesRow'
import NotesFilters from '../NotesFilters'
import { usePersonalAreaContext } from '../PersonalAreaContext'
import styles from '../PersonalAreaController.module.sass'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useEffect, useMemo, useState } from 'react'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import ReactMarkdown from 'react-markdown'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import moment from 'moment/moment'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

const RemindersController = () => {
	const { i18n, addNote } = useGlobal()
	const { selectedTab, reminders, isLoading } = usePersonalAreaContext()
	const { remindersContentUri, remindersContent, todayReminders } = reminders

	const [todayRemindersCollection, setTodayRemindersCollection] = useState([])
	const [dataCollection, setDataCollection] = useState([])
	const [searchTermQuery, setSearchTermQuery] = useState([])

	const [searchTodayRemindersTermQuery, setSearchTodayRemindersTermQuery] =
		useState([])

	const labels = {
		title: i18n`Today reminders`,
		nextRemindersTitle: i18n`Next reminders`,
		noContentMessage: searchTermQuery
			? i18n`There are no **matches**.`
			: i18n`There are no **reminders**.`,
		noContentMessageForTodayReminders: searchTodayRemindersTermQuery
			? i18n`There are no **matches**.`
			: i18n`There are no **reminders** for today.`,
	}

	const remainingReminders = useMemo(
		() =>
			remindersContent?.filter(
				(item) =>
					!item?.reminderDate?.momentDate?.isSame(moment(), 'day')
			),
		[remindersContent]
	)

	useEffect(() => {
		setDataCollection(remainingReminders)
	}, [remainingReminders])

	const handleDataCollectionWithTermSearch = (
		childData,
		childSearchTermQuery
	) => {
		setDataCollection(childData?.matches)
		setSearchTermQuery(childSearchTermQuery?.query)

		setTodayRemindersCollection(childData?.todayRemindersMatches)
		setSearchTodayRemindersTermQuery(
			childSearchTermQuery?.todayRemindersQuery
		)
	}

	return (
		<>
			<Widget
				paddings={['small', 'normal', '']}
				applyMaxWidth
				className={styles['filters-widget']}
			>
				<NotesFilters
					handleDataCollection={handleDataCollectionWithTermSearch}
					todayReminders={todayReminders}
					data={remainingReminders}
					className={styles['filters-options']}
					selectedTab={selectedTab}
				/>

				<ActionButton
					className={styles['icon-container']}
					onClick={() => {
						addNote &&
							addNote({
								remindersContentUri,
							})
					}}
				>
					<Icon name='plus' height='20px' width='20px' />
				</ActionButton>
			</Widget>

			<Widget
				paddings={['', '', '', '']}
				applyMaxWidth
				margins={['small', 'large', 'xsmall', 'large']}
			>
				<ExpandableWidget
					className={styles['today-widget']}
					titleAppearance='no-line'
					heading='h4'
					title={labels.title}
					expanded
					borderRadius
				>
					<VStack className={styles['content']}>
						{!isLoading && !todayRemindersCollection?.length ? (
							<ReactMarkdown
								className={styles['no-reminders']}
								allowedTypes={[
									'break',
									'paragraph',
									'strong',
									'text',
									'list',
									'listItem',
									'code',
								]}
								unwrapDisallowed={true}
							>
								{labels.noContentMessageForTodayReminders}
							</ReactMarkdown>
						) : (
							<>
								{(todayRemindersCollection || []).map(
									(item, idx) => (
										<NotesRow
											key={idx}
											noteItem={item}
											contentUri={remindersContentUri}
										/>
									)
								)}
							</>
						)}
					</VStack>
				</ExpandableWidget>
			</Widget>

			<Widget
				paddings={['', '', '', '']}
				applyMaxWidth
				margins={['', 'large', 'large', 'large']}
			>
				<ExpandableWidget
					className={styles['today-widget']}
					titleAppearance='no-line'
					expanded={true}
					heading='h4'
					title={labels.nextRemindersTitle}
					borderRadius
				>
					<VStack
						className={`${styles['content']} ${styles['--no-max-height']}`}
					>
						{!isLoading && !dataCollection?.length ? (
							<ReactMarkdown
								className={styles['no-reminders']}
								allowedTypes={[
									'break',
									'paragraph',
									'strong',
									'text',
									'list',
									'listItem',
									'code',
								]}
								unwrapDisallowed={true}
							>
								{labels.noContentMessage}
							</ReactMarkdown>
						) : (
							<>
								{(dataCollection || []).map((item, idx) => (
									<NotesRow
										key={idx}
										noteItem={item}
										contentUri={remindersContentUri}
									/>
								))}
							</>
						)}
					</VStack>
				</ExpandableWidget>
			</Widget>
		</>
	)
}

export default RemindersController
